<template>
  <td v-if="actions && actions.length > 0" class="table-actions">
    <template v-for="(action, index) in actions">
      <check-permission
        v-if="checkAction(action, object)"
        :key="action.permissions + '_' + action.event + '_' + index"
        :entity-id="action.entityId ? action.entityId : getEntityId(action)"
        :entity-type="action.entityType ? action.entityType : entityType"
        :permissions="action.permissions ? action.permissions : getPermissions(action.permissionTypes)"
      >
        <v-btn
          icon
          flat
          :aria-label="action.tooltipText"
          :class="action.class"
          :style="{ color: actionColor(action) }"
          @click.prevent="$emit(action.event, object)"
        >
          <v-icon>{{ action.icon }}</v-icon>
        </v-btn>
      </check-permission>
    </template>
  </td>
</template>

<script>
import { getPath } from '@witkac/utils/getPath';

// @vuese
// Akcje tabeli
// @group Table
export default {
  name: 'TActions',
  props: {
    // Ściezka do identyfikatora
    idPath: { type: String, required: false, default: 'id' },
    // Obiekt zawierający dane
    object: { type: Object, required: true },
    // Możliwe do wykonania akcje
    actions: { type: Array, required: false },
    // Typ encji wyświetlanej w tabeli
    entityType: { type: String, required: false }
  },
  methods: {
    // @vuese
    // Pobiera uprawnienie przycisku akcji
    getPermissions(permissionsTypes) {
      return permissionsTypes.map(permissionType => `${this.entityType.toUpperCase()}.${permissionType}`);
    },

    // @vuese
    // Zwraca identyfikator encji do uprawnień
    getEntityId(action) {
      if (action.entityIdPath) {
        return getPath(this.object, action.entityIdPath);
      }
      return getPath(this.object, this.idPath);
    },

    // @vuese
    // Sprawdza, czy akcja powinna być widoczna
    checkAction(action, object) {
      if (!action || !action.check) {
        return true;
      }
      if (typeof action.check === 'string') {
        action.check = new Function('object', 'action', action.check);
      }
      return action.check(object, action);
    },

    // @vuese
    // Zwraca kolor akcji
    actionColor(action) {
      if (typeof action.color === 'function') {
        return action.color(this.object);
      }
      return action.color;
    }
  }
};
</script>
